import { Badge } from './ui/badge';
import { X } from 'lucide-react';

export interface FilterPill {
  key: string;
  label: string;
  remove: () => void;
}

interface ActiveFilterPillsProps {
  pills: FilterPill[];
}

export function ActiveFilterPills({ pills }: ActiveFilterPillsProps) {
  if (pills.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1.5 pb-2">
      {pills.map(pill => (
        <Badge
          key={pill.key}
          variant="secondary"
          className="flex items-center gap-1.5 px-2.5 py-1 text-xs hover:bg-muted-foreground/10 transition-colors"
        >
          {pill.label}
          <button
            onClick={pill.remove}
            className="hover:bg-destructive hover:text-destructive-foreground rounded-full p-0.5 transition-colors"
            aria-label={`Remove ${pill.label} filter`}
          >
            <X className="h-3 w-3" />
          </button>
        </Badge>
      ))}
    </div>
  );
}